(() => {
  function init() {
    const menuButton = document.querySelector('.vp-menu-toggle');
    const header = document.querySelector('.vp-header');
    if (menuButton && !menuButton.dataset.ready) {
      menuButton.dataset.ready = 'true';
      function closeMenu() { header.classList.remove('vp-menu-open'); menuButton.setAttribute('aria-expanded', 'false'); }
      menuButton.addEventListener('click', () => {
        const open = menuButton.getAttribute('aria-expanded') !== 'true';
        menuButton.setAttribute('aria-expanded', String(open));
        header.classList.toggle('vp-menu-open', open);
      });
      document.querySelector('#vp-main-menu').addEventListener('click', event => { if (event.target.closest('a')) closeMenu(); });
      document.addEventListener('keydown', event => { if (event.key === 'Escape' && menuButton.getAttribute('aria-expanded') === 'true') { closeMenu(); menuButton.focus(); } });
      document.addEventListener('click', event => { if (!header.contains(event.target)) closeMenu(); });
    }
    const content = document.querySelector('[data-vp-content]');
    const toc = document.querySelector('[data-vp-toc]');
    const links = document.querySelector('[data-vp-sections]');
    if (!content || !toc || !links || toc.dataset.ready) return;
    toc.dataset.ready = 'true';
    const headings = Array.from(content.querySelectorAll('h2')).filter(el => el.textContent.trim());
    const entries = headings.map((heading, index) => {
      if (!heading.id) heading.id = 'vp-section-' + (index + 1);
      const link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent.trim();
      links.append(link);
      return { heading, link };
    });
    toc.hidden = !entries.length;
    if (matchMedia('(max-width:720px)').matches) toc.open = false;
    links.addEventListener('click', event => {
      if (event.target.closest('a') && matchMedia('(max-width:720px)').matches) toc.open = false;
    });
    // Keep the existing document date; this is a design change, not a policy revision.
    content.querySelectorAll('p').forEach(p => {
      if (/^Last updated:/i.test(p.textContent.trim())) p.dataset.vpUpdated = '';
    });
    let scheduled = false;
    function updateSection() {
      scheduled = false;
      let active = entries[0];
      for (const entry of entries) {
        if (entry.heading.getBoundingClientRect().top <= 160) active = entry;
      }
      entries.forEach(entry => {
        if (entry === active) entry.link.setAttribute('aria-current', 'location');
        else entry.link.removeAttribute('aria-current');
      });
    }
    window.addEventListener('scroll', () => {
      if (!scheduled) { scheduled = true; requestAnimationFrame(updateSection); }
    }, { passive: true });
    updateSection();
    document.addEventListener('vy:cart-state', event => {
      const count = document.querySelector('[data-vp-cart-count]');
      if (count) count.textContent = event.detail.itemCount ? ' (' + event.detail.itemCount + ')' : '';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
